import validate from 'validate.js';
import {differenceInMinutes, parseJSON} from 'date-fns';

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
};

export const validaGrupo = motivo => (
    (motivo ? validate(motivo, constraints) : {}) || {}
);